import { useCallback, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import AvatarPlaceholder from '@/components/avatar-default';
import { useAuth } from '@/provider/UserProvider';
import { postFollower } from '@/services/feed';
import { getFollowByAddress } from '@/services/follow';

import FeedContext from '../FeedContext';

const FollowerSuggestedItem: React.FC<any> = ({ follower }) => {
  const { username, publicAddress, picture, id } = follower || {};
  const { isLogin } = useAuth();
  const { data: contextData, contextActionGenerator } = useContext(FeedContext);
  const [infoFollower, setInfoFollower] = useState({
    isFollowing: false,
    numberOfFollowers: 0,
    numberOfFollowings: 0,
    numberOfNfts: 0,
  });
  const asyncPostFollower = useCallback(async () => {
    if (!isLogin) {
      return toast.error('Please connect your wallet');
    }
    if (id) {
      const [data]: any = await postFollower({ id });

      if (data) {
        contextActionGenerator?.setRefreshWhenFollowNewUser(id);
        contextActionGenerator?.setRefreshFollow(!contextData?.refreshFollow);
      }
    }
  }, [isLogin, contextActionGenerator, id]);

  const getInfoFollower = async () => {
    if (publicAddress) {
      const response = await getFollowByAddress(publicAddress);
      if (response?.data) {
        setInfoFollower(response?.data);
      }
    }
  };

  useEffect(() => {
    getInfoFollower();
  }, []);
  return (
    <div
      className="flex w-full flex-col items-start gap-4 rounded-3xl border-1 border-solid border-gray-100 bg-white p-[28px]"
      key={id}
    >
      <div className="flex w-full flex-col items-start gap-3">
        <div className="flex w-full items-start justify-between">
          <AvatarPlaceholder
            src={picture}
            alt="avatar-creators"
            className="h-10 w-10 rounded-full"
            address={publicAddress}
          />
          <button
            className="flex items-center justify-center gap-[10px] rounded-[100px] bg-gray-100 px-4 py-2 text-13 font-semibold text-black"
            type="button"
            onClick={asyncPostFollower}
          >
            Follow
          </button>
        </div>
        <div className="flex flex-col items-start">
          <p className="text-14 font-semibold text-black">{username}</p>
          {/* <p className="text-14 font-normal text-gray-500">johndoe123</p> */}
        </div>
      </div>
      <div className="h-[1px] w-full bg-gray-50" />
      <div className="flex items-start gap-6">
        <div className="flex flex-col items-start">
          <span className="text-16 font-semibold text-black">{infoFollower.numberOfFollowers}</span>
          <span className="text-[13px] font-semibold text-gray-400">Followers</span>
        </div>
        <div className="flex flex-col items-start">
          <span className="text-16 font-semibold text-black">
            {infoFollower.numberOfFollowings}
          </span>
          <span className="text-[13px] font-semibold text-gray-400">Following</span>
        </div>
        <div className="flex flex-col items-start">
          <span className="text-16 font-semibold text-black">${infoFollower.numberOfNfts}</span>
          <span className="text-[13px] font-semibold text-gray-400">Volume</span>
        </div>
      </div>
    </div>
  );
};

export default FollowerSuggestedItem;
